Vue.component('ack-application-workflow-collateral-icons', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-application-workflow-collateral-icons',
	mounted() {},
	props: {
		iconItems: {
			// :product-info
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		isShowArrowIcon: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('shop', ['productList']),
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('shop', ['addSelectedItem', 'removeSelectedItem']),
	},
	beforeDestroy() {},
	watch: {
		handler() {},
		deep: false,
	},
});
